import type { OutlinedIconSelectOption } from '../../shared/jepto-outlined-icon-select-field/jepto-outlined-icon-select-field.component';

/** Chart Type control options; values match `ChartCardConfig.chartType`. */
export const CHART_TYPE_CHOICES: OutlinedIconSelectOption[] = [
  { value: 'line', label: 'Line Chart', icon: 'show_chart' },
  { value: 'area', label: 'Area Chart', icon: 'area_chart' },
  { value: 'bar', label: 'Bar Chart', icon: 'bar_chart' },
  { value: 'column', label: 'Column Chart', icon: 'bar_chart' },
  { value: 'donut', label: 'Donut Chart', icon: 'donut_large' },
  { value: 'scatter', label: 'Scatter Chart', icon: 'scatter_plot' },
  { value: 'number', label: 'Number', icon: 'pin' },
];

/**
 * Chart types the editor can build form fields and Highcharts options for.
 * Used to reject unsupported types before they reach `ChartOptionsService`.
 */
const EDITOR_SUPPORTED_CHART_TYPES = new Set<string>(
  CHART_TYPE_CHOICES.map((c) => c.value)
);

export function isEditorSupportedChartType(chartType: string): boolean {
  return EDITOR_SUPPORTED_CHART_TYPES.has(chartType);
}
